import { render, staticRenderFns } from "./OrderCompaniesList.vue?vue&type=template&id=03cc89f9&scoped=true"
import script from "./OrderCompaniesList.vue?vue&type=script&lang=js"
export * from "./OrderCompaniesList.vue?vue&type=script&lang=js"
import style0 from "./OrderCompaniesList.vue?vue&type=style&index=0&id=03cc89f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc89f9",
  null
  
)

export default component.exports